import React, { useEffect, useState } from 'react';
import PaymentMethodSelector from '../../../organisms/selectors/PaymentMethodSelector';
import CheckoutSummary from '../../../organisms/cards/CheckoutSumary';
import { CheckoutService } from '../../../../services/CheckoutService';
import Button from '../../../atoms/buttons/Button';
import { useHistory } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import Input from '../../../atoms/inputs/Input';
import { ReactComponent as IxLoading } from '../../../../assets/imgs/ix-loading.svg';
import Icon from '../../../atoms/icons/Icon';
import Image from '../../../atoms/images/Image';
import { startCheckout } from '@easypaypt/checkout-sdk';
import Bugsnag from '@bugsnag/js';
const CheckoutPageTwo = ({ intl, ...props }) => {
  const {
    paymentMethods,
    selectedMethod,
    handlePaymentMethodChange,
    currentPlan,
    selectedPlan,
    currentCycle,
    selectedCycle,
    orderSummary = undefined,
    coupon = undefined,
    applyCoupon,
    couponError = false,
    couponSuccess = false,
    paymentMethod,
    forceNewPaymentMethod = false,
    fromParentIsLoading = true,
    preconditionError,
    setPreconditionError,
  } = props;

  const history = useHistory();
  const [summary, setSummary] = useState(orderSummary);
  const [paymentOperationStarted, setPaymentOperationStarted] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(true);
  const [paymentWidgetVisible, setPaymentWidgetVisible] = useState(false);
  const [orderCoupon, setOrderCoupon] = useState(coupon);
  const [transactionId, setTransactionId] = useState(undefined);
  const [checkoutInfo, setCheckoutInfo] = useState(undefined);
  const [changePayment, setChangePayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const paymentSuccessHandler = (checkoutInfo) => {
    setCheckoutInfo(checkoutInfo);
  };

  const paymentErrorHandler = (error) => {
    Bugsnag.notify(new Error(JSON.stringify(error)));
  };

  const paymentPaymentErrorHandler = (error) => {
    Bugsnag.notify(new Error(JSON.stringify(error)));
  };

  const paymentCloseHandler = () => {
    closeModal();
  };

  function easypayLanguage(locale) {
    if (locale === 'en') {
      return 'en';
    } else if (locale === 'pt') {
      return 'pt_PT';
    } else if (locale === 'es') {
      return 'es_ES';
    } else {
      return locale;
    }
  }

  const submitPaymentOrder = async () => {
    setPaymentOperationStarted(true);

    const response = await CheckoutService.paymentAuthorization(
      selectedPlan.id,
      selectedCycle,
      'EUR',
      [selectedMethod.payment_id],
      forceNewPaymentMethod ? false : !changePayment,
      summary
    );

    if (!response.error) {
      if (response.skip) {
        history.push({
          pathname: '',
          search:
            '?page=paymentResponse&checkoutInfo=' +
            JSON.stringify(response) +
            '&cycle=' +
            currentCycle +
            '&selectedCycle=' +
            selectedCycle +
            '&currentPlan=' +
            currentPlan?.id +
            '&selectedPlan=' +
            selectedPlan.id,
        });
      } else {
        setTransactionId(response.transaction_id);

        switch (selectedMethod.payment_id) {
          case 'CC':
          case 'MBW':
            startCheckout(response.manifest, {
              id: 'checkout-form',
              display: 'inline',
              hideDetails: true,
              backgroundColor: '#fbfbfc',
              accentColor: '#18BB80',
              errorColor: '#C11A1A',
              inputBackgroundColor: '#fbfbfc',
              inputBorderColor: '#c0c1c4',
              inputBorderRadius: 5,
              inputFloatingLabel: true,
              buttonBackgroundColor: '#18BB80',
              buttonBorderRadius: 5,
              buttonBoxShadow: false,
              buttonTextColor: '#fbfbfc',
              stepperTextColor: '#fbfbfc',
              hideDetailsButton: true,
              hideCartButton: true,
              hideSubscriptionSummary: true,
              linkColor: '#18BB80',
              language: easypayLanguage(intl.locale),
              fontFamily:
                'https://fonts.gstatic.com/s/oxygen/v15/2sDfZG1Wl4LcnbuKjk0mRUe0Aw.woff2',
              onSuccess: paymentSuccessHandler,
              onError: paymentErrorHandler,
              onPaymentError: paymentPaymentErrorHandler,
              onClose: paymentCloseHandler,
              testing: process.env.REACT_APP_EASYPAY_TESTING === 'true',
            });

            setTimeout(() => {
              setPaymentLoading(false);
              setPaymentWidgetVisible(true);
            }, 2000);
            break;

          case 'MB':
            let paymentReference = {
              entity: response.method.entity,
              reference: response.method.reference,
              amount: summary.amount_with_vat,
            };

            history.push({
              pathname: '',
              search:
                '?page=paymentResponse&checkoutInfo=' +
                JSON.stringify(paymentReference) +
                '&isReferencePayment=true&cycle=' +
                currentCycle +
                '&selectedCycle=' +
                selectedCycle +
                '&currentPlan=' +
                currentPlan?.id +
                '&selectedPlan=' +
                selectedPlan.id,
            });

            break;
          default:
            break;
        }
      }
    } else {
      console.error('Error:', response.error);
    }
  };

  useEffect(() => {
    if (summary === undefined && selectedPlan.id !== undefined) {
      const fetchOrderSummary = async () => {
        const response = await CheckoutService.submitOrderSummary(
          selectedPlan.id,
          selectedCycle,
          orderCoupon
        );

        if (!response.error) {
          if (response.status === 412) {
            Bugsnag.notify(new Error(response.summary));
            setPreconditionError(true);
          } else {
            setSummary(response.summary);
            setPreconditionError(false);
          }
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        } else {
          Bugsnag.notify(new Error(response.error));
        }
      };

      fetchOrderSummary();
    }
    // eslint-disable-next-line
  }, [selectedPlan]);

  useEffect(() => {
    const paymentSubscription = async () => {
      const response = await CheckoutService.paymentSubscription(
        selectedPlan.id,
        selectedCycle,
        summary.amount_with_vat,
        'EUR',
        [selectedMethod.payment_id],
        summary?.discount_coupon,
        summary?.discount_percentage,
        transactionId,
        checkoutInfo.payment.id
      );

      if (!response.error) {
        history.push({
          pathname: '',
          search:
            '?page=paymentResponse&checkoutInfo=' +
            JSON.stringify(response) +
            '&cycle=' +
            currentCycle +
            '&selectedCycle=' +
            selectedCycle +
            '&currentPlan=' +
            currentPlan?.id +
            '&selectedPlan=' +
            selectedPlan.id,
        });
      } else {
        Bugsnag.notify(new Error(response.error));
      }
    };

    if (transactionId !== undefined && checkoutInfo !== undefined) {
      paymentSubscription();
    } else {
      Bugsnag.notify(new Error('Transaction ID: ' + transactionId + ' Checkout Info: ' + JSON.stringify(checkoutInfo)));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionId, checkoutInfo]);

  useEffect(() => {
    if (orderSummary !== undefined) {
      setSummary(orderSummary);
    }
  }, [orderSummary]);

  useEffect(() => {
    if (couponError || couponSuccess) {
      setIsLoading(false);
    }
  }, [couponError, couponSuccess]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(fromParentIsLoading);
    }, 1000);
  }, [fromParentIsLoading]);

  const closeModal = () => {
    setPaymentWidgetVisible(false);
    setPaymentOperationStarted(false);
    setPaymentLoading(true);
    setTransactionId(undefined);
    setCheckoutInfo(undefined);
  };

  return (
    <div className='d-flex flex-column flex-grow-1 w-100'>
      <div className='checkout-layout__content d-flex flex-column-reverse flex-md-row w-100 h-100 justify-content-between'>
        <div className='d-flex col-12 col-md-6 px-0 mt-4 mt-md-0'>
          <div className='d-flex flex-column flex-grow-1'>
            <Paragraph className='text-header regular h4 brand pe-0 pe-md-3 mb-3'>
              {intl.messages['checkoutChoosePaymentMethod']}
            </Paragraph>
            <PaymentMethodSelector
              className='pe-0 pe-md-3 mb-4'
              paymentMethods={paymentMethods}
              selectedMethod={selectedMethod}
              selectedCycle={selectedCycle}
              onChange={handlePaymentMethodChange}
              paymentMethodInfo={paymentMethod}
              changePayment={changePayment}
              setChangePayment={setChangePayment}
            />

            <div className='coupon-container d-flex flex-column pe-0 pe-md-3'>
              <Paragraph className='text-paragraph text-black'>
                {intl.messages['checkoutCouponDescripion']}
              </Paragraph>

              <div className='d-flex flex-row w-100'>
                <Input
                  id='coupon_input'
                  className='flex-grow-1'
                  type='text'
                  placeholder='checkoutCouponPlaceholder'
                  value={orderCoupon}
                  onChange={(e) => setOrderCoupon(e.target.value)}
                />
                <Button
                  label={intl.messages['filterItemsPerPage']}
                  className='button button-outline px-5 ms-4'
                  disabled={isLoading}
                  onClick={() => {
                    if (orderCoupon !== '' && orderCoupon !== undefined) {
                      setIsLoading(true);
                      applyCoupon(orderCoupon);
                    }
                  }}
                />
              </div>
              {couponError && (
                <Paragraph className='alert-error bold mt-2'>
                  {intl.messages['checkoutCouponError']}
                </Paragraph>
              )}
              {couponSuccess && (
                <Paragraph className='alert-success bold mt-2'>
                  {intl.messages['checkoutCouponSuccess']}
                </Paragraph>
              )}
            </div>

            <div className='buttons-wrapper d-flex flex-column mt-5 pe-0 pe-md-3'>
              <Button
                label={intl.messages['next']}
                className='button w-100 button-primary'
                onClick={() => submitPaymentOrder()}
                disabled={preconditionError}
              />
              <Button
                label={intl.messages['goBack']}
                className='button w-100 button-plain-text mt-2'
                onClick={() =>
                  history.push({
                    pathname: '',
                    search:
                      '?page=one&cycle=' +
                      currentCycle +
                      '&selectedCycle=' +
                      selectedCycle +
                      '&selectedPlan=' +
                      selectedPlan.id,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className='d-flex col-12 col-md-6 px-0'>
          <div className='d-flex flex-column flex-grow-1'>
            <Paragraph className='text-header regular h4 brand ps-0 ps-md-3 mb-3'>
              {intl.messages['checkoutSummaryTitle']}
            </Paragraph>
            <CheckoutSummary
              className='flex-grow-1 ps-0 ps-md-3'
              upgrade={
                currentPlan?.id !== undefined &&
                currentPlan?.id !== selectedPlan.id
              }
              new_plan={selectedPlan}
              old_plan={currentPlan}
              summary={summary}
              cycle={selectedCycle}
              old_cycle={currentCycle}
              isLoading={isLoading}
              preconditionError={preconditionError}
            />
          </div>
        </div>
      </div>

      {paymentOperationStarted && (
        <div className='payment-widget-wrapper'>
          <div className='d-flex w-100 h-100 justify-content-center align-items-center position-relative'>
            {paymentLoading && (
              <div className='ix-loading-checkout'>
                <div className='ix-loading-checkout__container'>
                  <IxLoading />
                </div>
              </div>
            )}
            <div
              data-testid='payment-widget-container'
              className={`d-flex flex-column payment-widget-container position-relative ${
                paymentWidgetVisible ? 'visible' : 'hidden'
              }`}
            >
              <div className='d-flex flex-column w-100 justify-content-center align-items-center mt-5'>
                <Image
                  src='https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/ix-logo-horiz.svg'
                  alt='InvoiceXpress Logo'
                  className='logo'
                />
              </div>
              <div
                data-testid='close-icon'
                className='close-icon'
                onClick={() => closeModal()}
              >
                <Icon className='svg-inline--fa fa-xmark fa-w-11 icon fas fa-xmark' />
              </div>
              <div
                id='checkout-form'
                className='d-flex w-100 flex-grow-1 justify-content-center align-items-center'
              ></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default injectIntl(CheckoutPageTwo);
